// AI车队配置文件
// 线路规则：baseUrl 为美国 CN2 直连，baseUrlHk 为香港 CN2 中转（子域加 hk 后缀）
export const AI_FLEET_CONFIG = {
  grok: {
    baseUrl: 'https://grok.aimonkey.plus',
    baseUrlHk: 'https://grokhk.aimonkey.plus',
    authBridgePath: '/grok-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  claude: {
    baseUrl: 'https://c.aimonkey.plus',
    baseUrlHk: 'https://chk.aimonkey.plus',
    authBridgePath: '/claude-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  gemini: {
    baseUrl: 'https://gemini.aimonkey.plus',
    baseUrlHk: 'https://geminihk.aimonkey.plus',
    authBridgePath: '/gemini-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  sora: {
    baseUrl: 'https://sora.aimonkey.plus',
    authBridgePath: '/sora-auth-bridge.html',
    authApiPath: '/auth/loginToken'
  },

  'claude-v2': {
    baseUrl: 'https://c.aimonkey.vip',
    authBridgePath: '/claude-v2-auth-bridge.html',
    authApiPath: '/login'
  },

  'gpt-backup': {
    baseUrl: 'https://gpt.aimonkey.plus',
    authBridgePath: '/gpt-backup-auth-bridge.html',
    authApiPath: '/auth/login'  // 注意：GPT Plus车队使用不同的API路径
  }
};

// 根据线路获取 baseUrl
const resolveBaseUrl = (config, line) => {
  if (line === 'hk-cn2' && config.baseUrlHk) return config.baseUrlHk;
  return config.baseUrl;
};

// 获取完整的鉴权桥接URL
export const getAuthBridgeUrl = (fleetType, line = 'us-direct') => {
  const config = AI_FLEET_CONFIG[fleetType];
  if (!config) {
    throw new Error(`未找到 ${fleetType} 的配置`);
  }
  return `${resolveBaseUrl(config, line)}${config.authBridgePath}`;
};

// 获取鉴权API URL
export const getAuthApiUrl = (fleetType, line = 'us-direct') => {
  const config = AI_FLEET_CONFIG[fleetType];
  if (!config) {
    throw new Error(`未找到 ${fleetType} 的配置`);
  }
  return `${resolveBaseUrl(config, line)}${config.authApiPath}`;
};
